<template>
  <div class="rb-center-content">
    <div class="rb-popup-body" v-html="data.body"></div>
    <div class="rb-popup-links">
      <template v-for="index in 7">
        <div
          class="rb-popup-link"
          :key="`popup-link-${index}`"
          v-if="data[`link_title_${index}`]"
        >
          <template
            v-if="data[`link_url_${index}`].indexOf('jeandousset.as.me') > -1"
          >
            <a
              :href="data[`link_url_${index}`]"
              @click.prevent="notifyAcuity(data[`link_url_${index}`])"
            >
              <div class="rb-link-content flex align-items-center">
                <div
                  class="rb-link-icon"
                  v-html="data[`link_svg_${index}`]"
                ></div>
                <div class="rb-link-title">
                  {{ data[`link_title_${index}`] }}
                </div>
              </div>
              <div class="rb-link-icon">
                <icon-arrow-right />
              </div>
            </a>
          </template>
          <template v-else>
            <a :href="data[`link_url_${index}`]" target="_blank">
              <div class="rb-link-content flex align-items-center">
                <div
                  class="rb-link-icon"
                  v-html="data[`link_svg_${index}`]"
                ></div>
                <div class="rb-link-title">
                  {{ data[`link_title_${index}`] }}
                </div>
              </div>
              <div class="rb-link-icon">
                <icon-arrow-right />
              </div>
            </a>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
/**
 * Static Popup
 *
 * @summary
 * Data is created through customizer
 *
 * @implements
 * CommMixin
 *
 * @props
 * data: Object
 *
 * @emits
 * rb-acuity
 */
import CommMixin from "@/mixins/CommMixin";
import IconArrowRight from "@/components/icons/IconArrowRight";
export default {
  mixins: [CommMixin],
  components: { IconArrowRight },
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    notifyAcuity: function (url) {
      this.broadcast("rb-acuity", url);
    },
  },
};
</script>
